module.exports = __webpack_public_path__ + "static/skyrocket-788cd3e74104c4ea87b18b7004452bd6.svg";